import styled, { css } from 'styled-components/macro'

import { IconContract, IconArrowsRoundTrip, IconDislike } from '@loadsmart/icons'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { screen } from 'legacy/styles/screen'

export const ExpirationContainer = styled.div`
  color: ${getToken('color-neutral-white')};
`

export const ExpirationHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  color: ${getToken('color-neutral-white')};
  background-color: ${getToken('color-neutral-darker')};
`

const iconStyle = css`
  height: 24px;
  width: 24px;
  color: ${getToken('color-neutral-white')};
  margin-right: 8px;
`

export const ContractedIcon = styled(IconContract)`
  ${iconStyle};
`

export const LoadCandidateIcon = styled(IconArrowsRoundTrip)`
  ${iconStyle};
`

export const ExpirationTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  color: ${getToken('color-neutral-white')};
`

export const ExpirationDescription = styled.div`
  display: flex;
  align-items: center;
  text-align: right;
  font-size: 12px;
  font-weight: 400;
  flex-shrink: 1;

  ${screen.md} {
    flex-shrink: 0;
    font-size: 13px;
  }
`

export const ExpirationUrgency = styled.div`
  padding: 6px 12px;
  background-color: ${getToken('color-neutral-dark')};
`

export const ContractedBarSeparator = styled.div`
  background: ${getToken('color-neutral-dark')};
  width: 1px;
  height: 24px;
  content: ' ';
  margin: 0 15px;
`

export const RejectIcon = styled(IconDislike)`
  color: ${getToken('color-danger-light')};
  cursor: pointer;
  margin-top: 1px;
`
